if (!customElements.get('partner-inquiry-form')) {
  customElements.define(
    'partner-inquiry-form',
    class PartnerInquiryForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        // modal-dialog moves itself to <body> on connect, so it can no longer
        // be found with this.querySelector once upgraded — look it up by id.
        this.modal = this.dataset.modal ? document.querySelector(this.dataset.modal) : null;
        if (!this.form) return;

        this.submitButton = this.form.querySelector('[type="submit"]');
        this.form.addEventListener('submit', this.onSubmit.bind(this));
      }

      onSubmit(event) {
        event.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.setLoading(true);

        // A hard timeout guarantees the button always comes back to life for
        // the customer, even if the request hangs (dropped connection, a
        // security interstitial that never resolves, etc.) instead of
        // cleanly erroring — no timeout meant a stuck spinner with no way
        // to retry.
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 12000);

        fetch(this.form.getAttribute('action') || window.location.pathname, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(this.form),
          signal: controller.signal,
        })
          .then((response) => response.text())
          .then((responseText) => this.handleResponse(responseText))
          .catch(() => {
            // Fall back to a normal page submit (full navigation, no JS
            // required) so the customer's request still goes through
            // instead of dead-ending on a disabled button.
            this.setLoading(false);
            this.form.submit();
          })
          .finally(() => clearTimeout(timeout));
      }

      setLoading(isLoading) {
        this.submitButton.classList.toggle('loading', isLoading);
        this.submitButton.setAttribute('aria-disabled', String(isLoading));
        const spinner = this.submitButton.querySelector('.loading__spinner');
        if (spinner) spinner.classList.toggle('hidden', !isLoading);
      }

      handleResponse(responseText) {
        this.setLoading(false);

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const newForm = html.getElementById(this.form.id);

        if (!newForm) {
          this.form.submit();
          return;
        }

        const success = newForm.querySelector('.form-status.form-status-list');
        const errorHeading = newForm.querySelector('[role="alert"].form-status');

        if (success) {
          this.form.reset();
          if (this.modal) this.modal.show(this.submitButton);
          return;
        }

        if (errorHeading) {
          this.form.innerHTML = newForm.innerHTML;
          this.submitButton = this.form.querySelector('[type="submit"]');
          const focusTarget = this.form.querySelector('[autofocus]');
          if (focusTarget) focusTarget.focus();
          return;
        }

        this.form.submit();
      }
    }
  );
}
